export const isFirefox = (): boolean => {
  return /Firefox/.test(window.navigator.userAgent);
};
